// src/hooks/mediaConversion/useMediaConversionPanel.ts

import { useMemo } from "react";
import type { MediaConversionJobDTO } from "@/types/mediaConversion/mediaJob";
import type { MediaConversionPanelState } from "@/types/mediaConversion/mediaConversionTypes";
import { buildPanelState, filterJobsByField } from "@/utils/mediaConversion/mapping";

export function useMediaConversionPanel(
  jobs: MediaConversionJobDTO[],
  opts?: { fieldName?: string; staleAfterMs?: number }
): MediaConversionPanelState {
  return useMemo(() => {
    const filtered = filterJobsByField(jobs, opts?.fieldName);
    return buildPanelState(filtered, { staleAfterMs: opts?.staleAfterMs });
  }, [jobs, opts?.fieldName, opts?.staleAfterMs]);
}
